<template>
    <control-panel
        :breadcrumbs="breadcrumbsItems"
        :title="$t('app.sidebar_items.indicators')">
    </control-panel>
</template>

<script>
import ControlPanel from "@/Shared/ControlPanel";

export default {
    name: "IndicatorsHeader",

    components: {ControlPanel},

    props: {
        type: {
            type: Object,
        },
    },

    data() {
        return {
            search:"",
            breadcrumbsItems: [
                {
                    text: this.type.title,
                    disabled: true,
                },
                {
                    text: this.$t('indicators.types.generate'),
                    disabled: false,
                    href: route('indicators.index', {'type': this.type.id}),
                },
            ],
        }
    },

    methods: {        
    }

}
</script>

<style scoped>

</style>
